import GoTo from "@/app/shared/GoTo";
import { selectableColors } from "@/design/colors/colors";
import Avatar from "@/design/components/Avatar";
import { viLocationPinDot } from "@sippy-platform/valkyrie";

import { Divider, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function DestinationList({ timetable, setActiveDestination, activeDestination, getGoTo }) {
  const fallbackGoto = getGoTo(timetable.overflow);

  return (
    <>
      <ListItem disablePadding>
        <ListItemButton onClick={() => setActiveDestination(null)} selected={activeDestination === null}>
          <ListItemAvatar>
            <Avatar text="#fff" icon={fallbackGoto?.icon || viLocationPinDot} color="#fff" />
          </ListItemAvatar>
          <ListItemText
            primary={<GoTo target={fallbackGoto} hideType />}
            secondary={
              <>
                {timetable.overflow && Object.keys(timetable.overflow).length > 0 && (
                  <>
                    <GoTo target={fallbackGoto} type /> &middot;{" "}
                  </>
                )}
                Fallback destination
              </>
            }
          />
        </ListItemButton>
      </ListItem>
      <Divider sx={{ mx: 1, my: 0.75 }} />
      {selectableColors.map((color) => {
        const rule = timetable.rules.find((rule) => rule.color === color[500]);

        if (rule) {
          const goTo = getGoTo(rule.overflow);

          return (
            <ListItem disablePadding key={rule.color}>
              <ListItemButton onClick={() => setActiveDestination(rule)} selected={rule.id === activeDestination?.id}>
                <ListItemAvatar>
                  <Avatar text={rule.color} icon={goTo?.icon || viLocationPinDot} color={rule.color} />
                </ListItemAvatar>
                <ListItemText primary={<GoTo target={goTo} hideType />} secondary={<GoTo target={goTo} type />} />
              </ListItemButton>
            </ListItem>
          );
        }
      })}
    </>
  );
}

DestinationList.propTypes = {
  timetable: PropTypes.object,
  activeDestination: PropTypes.object,
  setActiveDestination: PropTypes.func,
  getGoTo: PropTypes.func,
};

export default DestinationList;
